import { Switch, Typography } from 'antd';
import { useContext } from 'react';
import { AppContext } from '../../../App';
import { formatToINR } from '../../../Utils/utils';
import styles from './NetWorthHeader.module.css';

export type NetWorthHeaderProps = {
    totalAmount: number;
    onChange: () => void;
}

const NetWorthHeader = ({totalAmount, onChange}: NetWorthHeaderProps) => {
  const { Text } = Typography;
  const {isAmountVisible}: any = useContext(AppContext)
  return (
    <div className={styles.profile}>
      <div className={styles.profileWorth}>
        <Text>Total Net Worth</Text>
        <Text>{formatToINR(String(totalAmount), isAmountVisible)}</Text>
      </div>
      <Switch
        value={isAmountVisible}
        onChange={onChange}
        className={styles.switch}
        style={{
          backgroundColor: 'var(--ct-segmented-filter-bg)',
        }}
      />
    </div>
  );
};

export default NetWorthHeader;
